import CircularProgress from '@mui/material/CircularProgress';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import React from 'react';

import { IStoriesSettingsMessages } from '../../../../types';
import { styles } from './StoryPreview.styles';

export type IStoryPreviewProps = {
  previewUrl: string;
  messages: IStoriesSettingsMessages;
  isPreviewLoading: boolean;
};

export const StoryPreview = ({ previewUrl, messages, isPreviewLoading }: IStoryPreviewProps) => {
  return (
    <Box sx={styles.root}>
      <Typography variant="h6">{messages.preview}</Typography>
      {isPreviewLoading && (
        <Box sx={styles.spinner}>
          <CircularProgress size={24} aria-label="Loading preview" />
        </Box>
      )}
      {!isPreviewLoading && previewUrl && (
        <Box component="img" src={previewUrl} alt={messages.previewAlt} sx={styles.previewImg} data-test="preview-image" />
      )}
    </Box>
  );
};
